<div class="container">
	<div class="body">
		<div class="logo">
			<a href="#">
				<img src="assets/media/company-logos/logo-2.png" alt="logo Fyffes">
			</a>
		</div>

		<div class="head">
			<h3>{{ 'AUTH.CHANGE_PASSWORD.EXPIRED' | translate }}</h3>
			<h6>{{ 'AUTH.CHANGE_PASSWORD.EXPIRED_MESSAGE' | translate }}</h6>
		</div>

		<kt-password-governance [isExpired]="true" [userEncoded]="user"></kt-password-governance>

	</div>
</div>
